import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faClock, faWalking, faArrowsAltH } from '@fortawesome/free-solid-svg-icons';

import { setSelectedPath } from '../store/actions/directionsActions';
import { setContentType } from '../store/actions/sideBarActions';
import { convertGeoJsonToGpx, getDurations, humanLength } from '../utils/utils';
import { CardInfoDetails } from '../components/Card/CardInfoDetails';
import { useLabelValue } from '../utils/useLabelValue';
import { PathDetails } from '../components/PathDetails';
import { FontAwesomeSvgIcon } from '../components/FontAwesomeSvgIcon';

function testAreEqual(prevRoad, nextRoad) {
  if(prevRoad.selectedPathFromUrl !== nextRoad.selectedPathFromUrl) {
    return false;
  } else if (prevRoad.status !== nextRoad.status) {
    return false;
  } else if (prevRoad.allResults !== nextRoad.allResults) {
    return false;
  } else if (prevRoad.selectedPath !== nextRoad.selectedPath) {
    return false;
  } 
  return true;
}

export const PathsCards = React.memo(function Path({
  status, 
  allResults, 
  selectedPath,   
  multimodalActivated = true
}) {
  const profil = useSelector(state => state.profils.profil);
  const condition = useSelector(state => state.profils.condition);
  const origin = useSelector(state => state.directions.origin);
  const dest = useSelector(state => state.directions.destination);
  const multimodal = useSelector(state => state.profils.multimodal);
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {setLabelProfile, setLabelCondition} = useLabelValue();

  const numberList = [t('pathcard.first_route'), t('pathcard.alternate_route'), t('pathcard.second_alternate_route')];


  const styles = {
    contentContainer : {
      display: 'flex',
      width: '100%'
    },
    headerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    timeContainer: {
      display: 'flex',
      paddingX: '.5em',
      fontSize: '1em',
      backgroundColor: 'transparent',
      alignItems: 'center'
    }
  };

  const openRoadMap = (cardNum) => {
    dispatch(setContentType('stepsDetails'));
    dispatch(setSelectedPath(cardNum));
  };

  const clickCardCallBack = (cardNum) => {
    dispatch(setSelectedPath(cardNum));
  };

  const handleExportGpx = (i) => {
    const label = `${t('common.itinerary')}_${i + 1}_${setLabelProfile(profil)}${condition && `_${setLabelCondition(condition)}`}`;
    const namePosition = `${t('common.gps_location', {origin: origin.label, dest: dest.label})}`;
    convertGeoJsonToGpx(allResults[i].geojson, label, namePosition, origin, dest);
  };
  

  const renderTimeWalking = (data, timeTotal) => {
    const {features} = data;
    if (features && features.length > 0) {
      const timeWalking = features.filter(elem => elem.properties.m !== 'transit').reduce((accumulator, obj) => {
        return Math.round(accumulator + obj.properties.time);
      }, 0);
      return (
        <Stack sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} direction='row' spacing={0} divider={<Divider orientation="vertical" flexItem />}>
          {timeTotal && multimodal && (
            <Chip sx={styles.timeContainer} icon={
              <FontAwesomeSvgIcon sx={{fontSize: '1.6em'}} icon={faClock} />
            } 
            label={getDurations(timeTotal)}
            />
          )}
          <Chip sx={styles.timeContainer} icon={
            <FontAwesomeSvgIcon sx={{fontSize: '1.6em'}} icon={faWalking} />
          } 
          label={getDurations(timeWalking)}
          />
        </Stack>
      );
    } 
  };

  return (
    <>
      {status === 'success' &&
    <Box component="ul" display='flex' flexDirection='column' backgroundColor='#F8F9FA' sx={{
      marginBlockStart: 0,
      marginBlockEnd: 0,
      paddingInlineStart: 0
    }}>
      {allResults.map((path, i) => {
        return (
          <CardInfoDetails key={i} component="li" id={`path_${i}`} active={selectedPath === i ? 'true' : 'false'}>
            <CardActionArea onClick={() => clickCardCallBack(i)}>
              <CardContent>
                <Stack sx={styles.contentContainer} direction='column' spacing={2}  divider={<Divider flexItem />}>
                  <Box sx={styles.headerContainer}> 
                    <Box>
                      <Typography sx={{ fontSize: '1.2em' }} gutterBottom>
                        {numberList[i]}
                      </Typography>
                    </Box>
                    <Chip sx={{paddingLeft: '.5em'}} icon={
                      <FontAwesomeSvgIcon icon ={faArrowsAltH} />
                    } label={humanLength(path.length)} />
                    {/* {path.time && (
                      <Chip label={getDurations(path.time)} />
                    )} */}
                  </Box>
                  {multimodalActivated && renderTimeWalking(path.geojson, path.time)}
                  {multimodalActivated && multimodal && (
                    <PathDetails data={path.geojson} />
                  )}
                </Stack>
              </CardContent>
            </CardActionArea>
            <CardActions sx={{display: 'flex', justifyContent: 'space-between'}}>
              <Button onClick={() => openRoadMap(i)} size="small">
                {t('pathcard.button-details')}
              </Button>
              <Button onClick={() => handleExportGpx(i)} disabled={allResults[i].length === 0} size="small">
                {t('export-data.button-gpx')}
              </Button>
            </CardActions>
          </CardInfoDetails>
        );
      })}
    </Box>
      }
      {status === 'loading' && 
    (
      <Box display='flex' sx={{width: '100%', justifyContent: 'center', paddingY: '1em', height: '100%'}} backgroundColor='#F8F9FA'>
        <CircularProgress  />
      </Box>
    )
      }
    </>
  );
}, testAreEqual);